import { useEffect, useState } from 'react';
import navIcon1 from '../assests/img/nav-icon1.svg';
import navIcon2 from '../assests/img/nav-icon2.svg';
import navIcon3 from '../assests/img/nav-icon3.svg';
import logo from '../assests/img/logo2.png';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

export const NavBar = () => {
    const [activeLink, setActiveLink] = useState('home');
    const [scrolled, setScrolled] = useState(false);

    useEffect( () =>{
        const onScroll = () =>{
            if(window.scrollY > 50){
                setScrolled(true);
            } else{
                setScrolled(false);
            }
        }
        window.addEventListener('scroll', onScroll);

        return () => window.removeEventListener('scroll', onScroll);

    }, [] )

    const onUpdateActiveLink = (value) =>{
   setActiveLink(value);
    }
  return (
    <Navbar expand="lg" className={scrolled? "scrolled": ""}>
      <Container>
        <Navbar.Brand href="#home" className='portfolio' style={{color: 'white', fontWeight:'700', fontSize:'22px'}}>
           <span>PORTFOLIO</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav">
        <span className='navbar-toggle-icon'><i className="fa-solid fa-bars" style={{color:'white'}}></i></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="#home" className={activeLink === 'home'? "active navbar-link": "navbar-link"} onClick={() => onUpdateActiveLink('home')}>Home</Nav.Link>
            <Nav.Link href="#skills" className={activeLink === 'skills'? "active navbar-link": "navbar-link"} onClick={() => onUpdateActiveLink('skills')}>Skills</Nav.Link>
            <Nav.Link href="#projects" className={activeLink === 'projects'? "active navbar-link": "navbar-link"} onClick={() => onUpdateActiveLink('projects')}>Projects</Nav.Link>
          </Nav>
          <span className='navbar-text'>
            <div className='social-icon'>
                <a href='https://linkedin.com/in/touseef-zakria-0a4333314' target='_blank' ><img src={navIcon1} alt=''/></a>
                <a href='https://www.facebook.com/touseefsatti.satti.3?mibextid=ZbWKwL' target='_blank' ><img src={navIcon3} alt=''/></a>
                <a href='https://www.instagram.com/touseef__z3?igsh=OW11Mm9wOTloNmR5' target='_blank' ><img src={navIcon2} alt=''/></a>
            </div>
            <button className='vvd' onClick={ () => console.log("coonect")}><span>Let's Connect</span></button>
          </span>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;